import React, { useContext } from 'react'
import PropTypes from 'prop-types'
import classnames from 'classnames'

import GlobalContext from 'agency/digital_renderer/utils/context'
import deviceStyle from 'agency/digital_renderer/utils/deviceStyle'
import AnimationWrapper from 'agency/digital_renderer/themes/RealhubDynamic/ui/AnimationWrapper'

import ElementContainer from '../../ElementContainer'
import styles from './styles.scss'

const filterAgentMediaLinks = (mediaLinks, agent) => {
  const agentLinks = {}

  if (agent && agent.media_links){
    agent.media_links.forEach((linkId) => {
      const mediaLink = mediaLinks[linkId] || {}
      if (mediaLink.link_type){
        agentLinks[`${mediaLink.link_type}_media_link`] = mediaLink
      }
    })
  }

  return agentLinks
}

const renderAgent = (container, agentIndex, campaign, agents, mediaLinks) => {
  const agentIds = campaign.agents || []
  const agentId = agentIds[agentIndex]
  const agent = agents[agentId]

  if (agent){
    const mergedAgent = {
      ...agent,
      ...filterAgentMediaLinks(mediaLinks, agent),
    }

    return (
      <ElementContainer
        callbacks={container.callbacks}
        forwardContextToItems={mergedAgent}
        section={container}
        renderNested
        render={({ itemComponents }) => itemComponents.map(component => component)}
      />
    )
  }

  return null
}

const Agent = (props) => {
  const { options } = props

  const {
    agentIndex, flexDirection, flexWrap, forceFlexDirection,
  } = options

  const style = deviceStyle(props)

  const container = { ...props }

  const proposalContent = useContext(GlobalContext)
  const { agents, campaign, mediaLinks } = proposalContent

  return (
    <AnimationWrapper options={options}>
      <div
        className={classnames(
          styles.root,
          flexDirection ? styles[flexDirection] : null,
          flexWrap ? styles[flexWrap] : null,
          forceFlexDirection ? styles.forceFlexDirection : null,
        )}
        style={style}
      >
        {renderAgent(container, agentIndex, campaign, agents, mediaLinks)}
      </div>
    </AnimationWrapper>
  )
}

Agent.propTypes = {
  options: PropTypes.object,
  style: PropTypes.object,
}

Agent.defaultProps = {
  options: {},
}

export default Agent
